/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Form, Input, Button, Row, Col, Select, Space } from 'antd';
import SPVehicleCascader from '../SPVehicleCascader';
import emiter, {
	EVENT_VEHICLE_SEARCH_LIST,
	EVENT_VEHICLE_RESEARCH,
	EVENT_CARRENTAL_VEHICLE_OCCUPSUMMARY_SEARCH
} from '../../../../events';
import request from '../../../../request';
import { API_VEHICLE_GET_STORE } from '../../../../hooks/carRental/_';
import {DEFAULT_PAGE_INFO} from "../../../../consts";
interface PropsType {
	enums?: any;
}

interface MyFormData {
	veh_plate: string;
	store_id: string;
	vehicle: string;
	veh_num_type: string;
	user: string;
	status: number;
}

const SPVehicleSearchForm: React.FC<PropsType> = props => {
	const { enums } = props;

	const searchFormFields = {
		chepaihao: {
			name: 'encrypt_veh_plate',
			label: '车牌号',
			required: false,
			message: '车牌号错误!',
			placeholder: '请输入',
		},
		teshupaizhao: {
			name: 'veh_num_type',
			label: '特殊牌照',
			required: false,
			message: '特殊牌照错误!',
			placeholder: '请选择',
		},
		// zuhu: {
		// 	name: 'user',
		// 	label: '租户',
		// 	required: false,
		// 	message: '租户错误!',
		// 	placeholder: '请选择',
		// },
		mendian: {
			name: 'store_code',
			label: '门店',
			required: false,
			message: '门店错误!',
			placeholder: '请选择',
		},
		zhuangtai: {
			name: 'status',
			label: '状态',
			required: false,
			message: '状态错误!',
			placeholder: '请选择',
		},
		shenhezhuangtai: {
			name: 'check_status',
			label: '审核状态',
			required: false,
			message: '审核状态错误!',
			placeholder: '请选择',
		},
	};

	const [searchForm] = Form.useForm();
	const [storeList, setStoreList] = useState([]);

	const onSearchFormFinish = (value: MyFormData) => {
		emiter.emit(
			EVENT_VEHICLE_SEARCH_LIST,
      {
        ...searchForm.getFieldsValue(),
        ...DEFAULT_PAGE_INFO
      }
		);
	};

	const clearSearch = () => {
		searchForm.resetFields();
		emiter.emit(EVENT_VEHICLE_SEARCH_LIST, {
      ...searchForm.getFieldsValue(),
      ...DEFAULT_PAGE_INFO
    });
	};

	const getStoreList = () => {
		request({
			url: API_VEHICLE_GET_STORE,
			method: 'GET',
		}).then((res: any) => {
			setStoreList(res.data);
		});
	};

	useEffect(() => {
		getStoreList();
		emiter.on(EVENT_VEHICLE_RESEARCH, onSearchFormFinish);
		return () => {
			emiter.removeAllListeners(EVENT_VEHICLE_RESEARCH)
		}
	}, []);

	return (
		<Form form={searchForm} onFinish={onSearchFormFinish}>
			<Row gutter={24}>
				<Col span={8}>
					<Form.Item
						name={searchFormFields.chepaihao.name}
						label={searchFormFields.chepaihao.label}
						rules={[
							{
								required: searchFormFields.chepaihao.required,
								message: searchFormFields.chepaihao.message,
							},
						]}
					>
						<Input placeholder={searchFormFields.chepaihao.placeholder} allowClear />
					</Form.Item>
				</Col>
				<Col span={8}>
					<SPVehicleCascader isRequired={false} />
				</Col>
				<Col span={8}>
					<Form.Item
						name={searchFormFields.teshupaizhao.name}
						label={searchFormFields.teshupaizhao.label}
						initialValue={-1}
						rules={[
							{
								required: searchFormFields?.teshupaizhao.required,
								message: searchFormFields?.teshupaizhao.message,
							},
						]}
					>
						<Select
							placeholder={searchFormFields.teshupaizhao.placeholder}
							options={(enums as any)?.veh_num_type}
							fieldNames={{ label: 'value', value: 'key' }}
						/>
					</Form.Item>
				</Col>
			</Row>
			<Row gutter={24}>
				{/* <Col span={8}>
					<Form.Item
						name={searchFormFields.zuhu.name}
						label={searchFormFields.zuhu.label}
						rules={[
							{
								required: searchFormFields?.zuhu.required,
								message: searchFormFields?.zuhu.message,
							},
						]}
					>
						<Select
							placeholder={searchFormFields.zuhu.placeholder}
							options={(enums as any).yesNo}
							fieldNames={{ label: 'value', value: 'key' }}
							allowClear
						/>
					</Form.Item>
				</Col> */}
				<Col span={8}>
					<Form.Item
						name={searchFormFields.mendian.name}
						label={searchFormFields.mendian.label}
						rules={[
							{
								required: searchFormFields?.mendian.required,
								message: searchFormFields?.mendian.message,
							},
						]}
					>
						<Select
							placeholder={searchFormFields.mendian.placeholder}
							allowClear
							showSearch
							optionFilterProp="children"
						>
							{storeList &&
								storeList.map((item: any) => (
									<Select.Option value={item.store_code} key={item.store_code}>
										{item.store_name}
									</Select.Option>
								))}
						</Select>
					</Form.Item>
				</Col>
				<Col span={8}>
					<Form.Item
						name={searchFormFields.zhuangtai.name}
						label={searchFormFields.zhuangtai.label}
						initialValue={-1}
						rules={[
							{
								required: searchFormFields?.zhuangtai.required,
								message: searchFormFields?.zhuangtai.message,
							},
						]}
					>
						<Select
							placeholder={searchFormFields.zhuangtai.placeholder}
							options={(enums as any)?.veh_status}
							fieldNames={{ label: 'value', value: 'key' }}
						/>
					</Form.Item>
				</Col>
				<Col span={8}>
					<Form.Item
						name={searchFormFields.shenhezhuangtai.name}
						label={searchFormFields.shenhezhuangtai.label}
						initialValue={-1}
						rules={[
							{
								required: searchFormFields?.shenhezhuangtai.required,
								message: searchFormFields?.shenhezhuangtai.message,
							},
						]}
					>
						<Select
							placeholder={searchFormFields.shenhezhuangtai.placeholder}
							options={(enums as any)?.veh_check_status}
							fieldNames={{ label: 'value', value: 'key' }}
						/>
					</Form.Item>
				</Col>
			</Row>
			<Space>
				<Button type="primary" htmlType="submit">
					查询
				</Button>
				<Button onClick={clearSearch}>清空</Button>
			</Space>
		</Form>
	);
};

export default SPVehicleSearchForm;
